import ProductLandingTemplate from "./ProductLandingTemplate";

const product = {
  slug: "bankszamla",
  name: "Bankszámla",
  description:
    "Nézd meg, melyik bankszámla passzol a bankolási szokásaidhoz: utalás, kártyahasználat, készpénzfelvétel.",
  highlights: [
    "Akciós és kedvezményes számlacsomagok",
    "Várható havi költségek összehasonlítása",
    "Egyszerű váltási támogatás",
  ],
};

export default function BankszamlaPage() {
  return (
    <ProductLandingTemplate
      product={product}
      iframeSrc="https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel"
    />
  );
}
